export default "__VITE_ASSET__2fd95a67__"